<template>
  <div class="custom-scrollbar">
    <div id="requirement-container">
      <loading :active.sync="loading"></loading>
      <b-card class='section'>
        <div id="requirement-header">
          <requirement-status-badge v-if="!isNew && requirement.status" :status="requirement.status"
            style="height: 3rem; padding:0.6rem; font-size:0.9em;">
            {{ requirement.status }}
          </requirement-status-badge>
          <span class="badge">
            {{ projectName }}
          </span>
          <!-- <span class="badge status-tag" :class="statusTagStyle" v-if="!isNew">
            {{ requirement.status }}
          </span> -->
          <div class='title-wrap'>
            <span class="id">{{ id }}</span>
            <input type="text" :class="{ 'is-invalid': invalidErrors.title }" placeholder="title"
              v-model="requirement.title" ref="title">
            <span v-if="invalidErrors.title" class="invalid-msg">{{ invalidErrors.title }}</span>
          </div>
          <CustomSelectBox label="Type" :options="typeOptions" :value="requirement.type"
            @onChange="onChangeTypeHandler" />
        </div>
      </b-card>
      <b-card class="section description">

        <!-- <editor :init="editorOption" api-key="s1t9wwcunl5fft6uu8vm5p9jl3w1jd4tpbqjym0ilhwb4z0j" -->
          <editor :init="editorOption" api-key="zwybj7ujqd6rsjj8fm19oc1u9ctrzmbv0ym5tqfsi29kbs7a"
          v-model="requirement.description" ref="description" />
        <span v-if="invalidErrors.description" class="invalid-msg">{{ invalidErrors.description }}</span>
      </b-card>

      <b-card class="section">
        <file-input @onChange="handleFileUpload" placeholder="파일을 업로드 해주세요." />
        <div class="file-list">
          <template v-for="(file, index) in files">
            <div v-if="!file.deleted" :key="index" class="d-flex file-item">
              <div class="file-info-area">
                <span class="file-name file-info-area_item">{{ file.name }}</span>
                <div>
                  <div class="image-item" :key="`${file.name}-${index}`">
                    <div v-if="isImage(file)" @click="openImageInNewWindow(file.url)">
                      <img :src="file.url" class="image-box" />
                    </div>
                  </div>
                </div>
                <div class="file-desc-area file-info-area_item">
                  <div>
                    <b-input-group>
                      <b-form-input name="fileDesc" type="text" class="custom-input" style="font-size: 0.899rem"
                        placeholder="Type Description" maxlength="50s" v-model="file.description">
                      </b-form-input>
                    </b-input-group>
                  </div>
                </div>
                <span class="file-upload-time file-info-area_item">{{ file.creationDate }}</span>
                <div class="file-info-area_item file-size">
                  {{ formatFileSize(file.size) }}
                </div>
                <div class="file-info-area_item" style="flex: 1;">
                  <base-button v-if="!file.new" class="btn btn-file-download" variant="primary" size="xs"
                    @click="downloadFile(file)">Download
                  </base-button>
                </div>
              </div>
              <b-badge variant="danger" class="btn btn-delete" @click="deleteFile(file)">Delete
              </b-badge>
            </div>
          </template>
        </div>
        <div class="file-size ready-to-upload">
          Ready to upload: {{ formatFileSize(readyToUploadFileSize) }}
          <span>* You can upload 100MB at a time.</span>
        </div>
        <div class="file-size total">
          Total: {{ formatFileSize(totalFileSize) }}
        </div>
      </b-card>

      <b-card v-if="!isNew" id="requirement-tabs" class='section comment related'>
        <b-tabs style="width:100%">
          <b-tab @click="activeRevisionTabIdx = -1">
            <template #title>
              <div class="comment-title-area">
                <span class="tab-title">
                  Comment
                </span>
                <span class="total-num">{{ comments.length }}</span>
              </div>
            </template>

            <div class="comment-area">
              <div class="comment-list-wrap">
                <div v-if="comments.length > 0" class="comment-list">
                  <!-- card -> div로 마크업 변경 -->
                  <div v-for="comment in comments" :key="comment.id" class="comment-item">
                    <requirement-comment-item v-bind={...comment}>
                    </requirement-comment-item>
                  </div>
                </div>
              </div>
              <!-- New Reply Form-->
              <b-card class="comment-reply">
                <vue-editor :editorOptions="{ modules: { toolbar: true } }" v-model="comment" class="comment-input"
                  style="border:none"></vue-editor>
              </b-card>
              <!-- /New Reply Form -->
            </div>
            <!-- /Posted Replies -->
          </b-tab>
          <b-tab @click="activeRevisionTabIdx = -1">
            <template #title>
              <div class="comment-title-area">
                <span class="tab-title">
                  Timeline
                </span>
                <span class="total-num">{{ timelineCount }}</span>
              </div>
            </template>
            <div class="timeline-area">
              <requirement-timeline @showRevision="showRevision" v-if="timelineDataGroupByDate"
                :propTimelineData="timelineDataGroupByDate" />
            </div>
          </b-tab>
          <template v-for="(description, index) in descriptionRevisionHistory">
            <b-tab :active="activeRevisionTabIdx === index">
              <template #title>
                <div class="tab-title">
                  Revision {{ index + 1 }}
                </div>
              </template>
              <div class="revision-area" v-html="description"></div>
            </b-tab>
          </template>
        </b-tabs>
      </b-card>
    </div>

    <div v-if="!isNew" class="btn-wrap">
      <div v-if="!isNew" class="button-container">
        <div></div>
        <div class="text-container" style="display:flex; align-self: center; flex-direction: column;">
          <span class="d-flex text">
            <span style="text-align: end; width: 100px; margin-right: 0.3em;">Created by</span> 
            {{ `${requirement.creatorName} (${requirement.creatorId}) at ${requirement.creationDate}` }}
          </span>
          <span class="d-flex text" v-if="requirement.updaterId != null" style="text-align : right;">
            <span style="text-align: end; width: 100px; margin-right: 0.3em;">Updated by</span> 
            {{ `${requirement.updaterName} (${requirement.updaterId}) at ${requirement.updatedDate}` }}
          </span>
        </div>

        <div class="d-flex align-items-end">
          <base-button style="margin-right: 1rem" @click="cancel" variant="default" size="sm">Cancel</base-button>
          <base-button :disabled="!isChangedForm" @click="updateRequirement" variant="primary" size="lg">Update</base-button>
        </div>
      </div>
    </div>
    <div v-if="isNew" class="btn-wrap d-flex align-items-end justify-content-end">
      <base-button @click="cancel" variant="default" size="sm">Cancel</base-button>
      <base-button :disabled="!hasFormContent" variant="primary" size="lg" @click="createRequirement">Create</base-button>
    </div>
  </div>
</template>
<script>
import Loading from 'vue-loading-overlay';
import CustomSelectBox from './CustomSelectBox.vue';
import Editor from '@tinymce/tinymce-vue';
import FileInput from './FileInput.vue';
import BaseButton from './BaseButton.vue';
import RequirementStatusBadge from './RequirementStatusBadge.vue';
import RequirementCommentItem from './RequirementCommentItem.vue';
import { VueEditor } from 'vue2-editor';
import RequirementTimeline from './RequirementTimeline.vue';

export default {
  name: 'RequirementDetail',
  props: {
    id: {
      type: String,
      required: false,
      default: ""
    },
    projectId: {
      type: String,
      required: false,
    }
  },
  components: {
    CustomSelectBox,
    Editor,
    FileInput,
    BaseButton,
    RequirementStatusBadge,
    RequirementCommentItem,
    VueEditor,
    RequirementTimeline
  },
  watch: {
    '$route.params.id': {
      handler(newRoute, oldRoute) {
        this.initRequirement(newRoute);
      },
      immediate: false // 컴포넌트가 생성될 때도 watch 핸들러를 호출할지 여부 설정
    },
  },
  async created() {
    try {
      this.$store.dispatch('chatter/retrieveAssigneeOptions')

      if (!this.isNew) {
        this.initRequirement(this.id);
      } else {
        if (!this.projectId) {
          await this.showMessage("올바르지 않은 접근입니다.");
          this.$router.replace("/chatter/requirement-list");
        }
        this.requirement.projectId = this.projectId;
      }
    } catch (e) {
      this.loading = false;
    }
  },
  computed: {
    projectName() {
      if (!this.requirement.projectId) return '';
      const project = this.$store.getters['chatter/projectOptions'].filter(project => project.projectId === this.requirement.projectId)[0];
      if (!project) return '';
      return project.name;
    },
    isNew() {
      return this.id ? false : true;
    },
    typeOptions() {
      return this.$store.getters['requirement/typeOptions'];
    },
    totalFileSize() {
      let sum = 0;
      this.files.forEach(file => {
        if (!file.deleted) {
          sum += file.size;
        }
      });

      return sum;
    },
    readyToUploadFileSize() {
      let sum = 0;
      this.files.forEach(file => {
        // 파일이 삭제되지 않고 새로운 파일일 경우에 크기 합
        if (!file.deleted && file.new) {
          sum += file.size;
        }
      })
      return sum;
    },
    hasFormContent() {
      if (this.requirement.title && this.requirement.title.trim()) {
        return true;
      }

      if (this.requirement.description && this.requirement.description.trim()) {
        return true;
      }

      if (this.requirement.type != 'FUNC') {
        return true;
      }

      const newFiles = this.files.filter(item => item.new && !item.deleted);
      if(newFiles.length > 0) {
        return true;
      }

      return false;
    },
    isChangedRequirement() {
      // if(this.isNew) return false;

      if(!this.prevRequirementState) {
        return false;
      }

      const compareFields = ['title', 'type', 'description'];

      for (let i = 0; i < compareFields.length; i++) {
        const field = compareFields[i];
        
        if(this.prevRequirementState.requirement[field].replaceAll('&nbsp;', ' ') !== this.requirement[field].replaceAll('&nbsp;', ' ')) {
          return true;
        }
      }

      if(this.comment) {
        return true;
      }

      return false;
    },
    isChangedFiles() {
      if(this.isNew) return false;

      for (let i = 0; i < this.files.length; i++) {
        const file = this.files[i];
        // 추가된 파일
        // new 가 true고 deleted가 false인 파일이 있으면
        if (file.new && !file.deleted) {
          return true;
        }

        // 삭제된 파일
        // new가 false고 deleted가 true인 파일이 있으면
        if (file.deleted && !file.new) {
          return true;
        }

        // new가 false, deleted도 false면
        // description 필드가 변경되었는지 확인 필요
        const findPrevFile = this.prevRequirementState.files.find((prevFile) => {
          prevFile.id === file.id;
        })
        
        // new가 true, deleted도 true인 경우
        // 이전 파일이 없을 수 있음

        if (findPrevFile && (findPrevFile.description !== file.description)) {
          return true;
        }
      } 
      // 삭제된 파일
      // 이전 -> 현재로 비교해서
      // 찾은 결과가 없거나
      // 찾았는데 new : false, deleted: false인 파일
      // for (let i = 0; i < this.prevRequirementState.files.length; i++) {
      //   const targetFileId = this.prevRequirementState.files[i].id;

      //   const findFile = this.files.find(currFile => {
      //     targetFileId === currFile.id;
      //   })

      //   if (!findFile) {
      //     return true;
      //   }
      //   // 찾은 파일이 있으면 해당 파일의 deleted 속성이 true인지 확인
      //   if (findFile && findFile.deleted) {
      //     return true;
      //   }
      // }
      // // 추가된 파일
      // // 현재 -> 이전으로 비교해서
      // // 찾은 결과가 없고 현재 파일이 new가 true고 deleted가 false인 경우
      // for (let i = 0; i < this.files.length; i++) {
      //   const targetFileId = this.files[i].id;

      //   const findFile = this.prevRequirementState.files.find(prevFile => {
      //     targetFileId === prevFile.id;
      //   });

      // }

      // 업데이트된 파일
      return false;
    },
    isChangedForm() {
      return this.isChangedRequirement || this.isChangedFiles;
    }
  },
  data() {
    return {
      loading: false,
      requirement: {
        id: null,
        projectId: null,
        projectName: null,
        title: null,
        description: null,
        type: 'FUNC',
        accept: 'N',
        creatorId: null,
        creatorName: null,
        creatorProfileImagePath: null,
        updaterId: null,
        updaterName: null,
        updaterProfileImagePath: null,
        creationDate: "2024-05-23 10:31:25",
        updatedDate: null
      },
      comment: null,
      files: [],
      comments: [],
      prevRequirementState: '',
      prevFilesState: '',
      timelineDataGroupByDate: '',
      timelineCount: 0,
      activeRevisionTabIdx: '',
      descriptionRevisionHistory: [],
      invalidErrors: {},
      prevRequirementState: '',
      editorOption: {
        menubar: "file edit view insert format tools table help",
        readonly: true,
        plugins: [
          'advlist autolink lists link image charmap print preview anchor',
          'searchreplace visualblocks code fullscreen',
          'insertdatetime media table paste code help wordcount'
        ],
        textpattern_patterns: [
          { start: '\n', replacement: '<br>' }
        ],
        forced_root_block: false,
        setup: function (editor) {
          editor.on('keydown', function (e) {
            if (e.key === 'Enter') {
              if (e.shiftKey) {
                // Shift + Enter: Insert <br> instead of <p>
                editor.execCommand('InsertLineBreak');
                e.preventDefault();
              } else {
                // Enter: Insert <br> instead of <p>
                editor.execCommand('InsertLineBreak');
                e.preventDefault();
              }
            }
          });
        },
        formats: {
          paragraph: { block: 'p', classes: 'paragraph', styles: {} },
          linebreak: { block: 'br', wrapper: true, remove: 'all' }
        },
        toolbar: 'undo redo | bold italic underline strikethrough | fontfamily fontsize blocks | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media template link anchor codesample | ltr rtl',
        paste_data_images: true,
        image_advtab: true,
        statusbar: false,
        contextmenu: false,
      },

    }
  },
  methods: {
    async initRequirement(id) {
      this.comment = null;

      this.loading = true;
      const { requirement, files, comments, history } = await this.fetchRequirement(id);
      this.requirement = requirement;
      this.files = files.map((file) => { return { ...file, deleted: false, new: false } });
      this.comments = comments;
      const groupedData = {};
      const descriptionRevisionHistory = [];
      this.timelineCount = history.length;
      // 날짜별로 히스토리 데이터를 그룹화
      history.forEach((item) => {
        const dateKey = item.creationDate.split(' ')[0];


        if (item.changedAttributeState.description) {
          descriptionRevisionHistory.push(item.changedAttributeState.description.currentValue);
        }

        if (!groupedData[dateKey]) {
          groupedData[dateKey] = [];
        }

        groupedData[dateKey].push(item);
      });

      this.descriptionRevisionHistory = descriptionRevisionHistory;
      this.timelineDataGroupByDate = groupedData;

      // 업데이트 시 이전 상태를 추적하기 위한 변수 초기화
      this.prevRequirementState = {
        requirement: JSON.parse(JSON.stringify(this.requirement)),
        files: JSON.parse(JSON.stringify(this.files)),
        comments: JSON.parse(JSON.stringify(this.comments)),
      }
      this.loading = false;
    },
    async fetchRequirement(id) {
      const response = await axios.get(`chatter/retrieveRequirement/${id}`, {
        headers: {
          Authorization: accessToken()
        }
      }
      );

      const status = response.data.status;
      if (status === "200") {
        const body = response.data.body;
        return body;
      } else {

      }
    },
    onChangeAcceptHandler(value) {
      this.requirement = {
        ...this.requirement,
        accept: value
      };
    },
    onChangeTypeHandler(value) {
      this.requirement = {
        ...this.requirement,
        type: value
      };
    },
    isImage(file) {
      return !file.deleted && file.contentType && file.contentType.includes('image')
    },
    async handleFileUpload(files) {
      for (const file of files) {
        const clone = new File([file], file.name, { type: file.type });
        let fileInfo = {
          id: -1,
          name: file.name,
          path: '',
          description: null,
          file: clone,
          new: true,
          deleted: false,
          url: '',
          size: file.size,
        };
        // fileInfo.url = this.isImage(fileInfo) ? await this.createFileURL(fileInfo) : null
        this.files.push(fileInfo);
      }
    },
    deleteFile(file) {
      file.deleted = true;
    },

    validateRequirement() {
      this.invalidErrors = {};


      if (!this.requirement.title) {
        this.invalidErrors.title = "Title is required";
        this.$refs.title.focus();
        return false;
      }

      if (!this.requirement.description) {
        this.invalidErrors.description = "Description is required";
        this.$refs.description.editor.focus();
        return false;
      }

      return true;
    },

    async createRequirement() {
      if (!this.validateRequirement()) {
        return;
      }

      const formData = new FormData();
      formData.append("projectId", this.requirement.projectId);
      formData.append("title", this.requirement.title);
      formData.append("description", this.requirement.description);
      formData.append("type", this.requirement.type);

      for (let idx = 0; idx < this.files.length; idx++) {
        if (!this.files[idx].delete) {
          formData.append(`files[${idx}].file`, this.files[idx].file);
          if (this.files[idx].description != null) {
            formData.append(`files[${idx}].description`, this.files[idx].description);
          }
        }
      }

      if (formData.keys().next().done) {
        this.$bvToast.toast(`Requirement를 작성해주세요.`, {
          title: `Notification`,
          toaster: "b-toaster-bottom-center",
          solid: true,
          appendToast: false,
          autoHideDelay: 400,
          variant: "danger"
        })
        return;
      }

      // 파일
      // new: true, delete:false 인 것만 
      const response = await axios.post('chatter/createRequirement',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: accessToken()
          }
        });

      const status = response.data.status;
      if (status === "200") {
        // this.$router.push(`/chatter/requirement-list`);
        const createdId = response.data.body.id;
        this.$router.replace(`/chatter/requirement/${createdId}`);
      } else {

      }
    },

    async updateRequirement() {
      try {

        this.loading = true;
        if (!this.validateRequirement()) {
          this.loading = false;
          return;
        }

        const formData = new FormData();
        if (this.prevRequirementState.requirement.title !== this.requirement.title) {
          formData.append("title", this.requirement.title);
        }
        if (this.prevRequirementState.requirement.description !== this.requirement.description) {
          formData.append("description", this.requirement.description);
        }
        if (this.prevRequirementState.requirement.type !== this.requirement.type) {
          formData.append("type", this.requirement.type);
        }
        if (this.prevRequirementState.requirement.accept !== this.requirement.accept) {
          formData.append("accept", this.requirement.accept);
        }

        if (this.comment !== null && this.comment.trim()) {
          formData.append("comment", this.comment);
        }

        let updateFileCount = 0;
        let uploadFileCount = 0;
        const deleteFileIds = [];
        for (let idx = 0; idx < this.files.length; idx++) {
          const file = this.files[idx];

          // 삭제파일
          if (!file.new && file.deleted) {
            deleteFileIds.push(file.id);
          } else if (file.new && !file.deleted) {  // 새로 업로드한 파일
            formData.append(`files[${uploadFileCount}].file`, file.file);
            if (file.description !== null && file.description.trim() !== "") {
              formData.append(`files[${uploadFileCount}].description`, file.description);
            }
            uploadFileCount++;
          } else {
            // description이 변경되었는지 확인
            const prevFile = this.prevRequirementState.files.find(prevItem => prevItem.id === file.id);
            if (prevFile && prevFile.description !== file.description) {
              formData.append(`updateFiles[${updateFileCount}].id`, file.id);
              formData.append(`updateFiles[${updateFileCount}].description`, file.description);
              updateFileCount++;
            }
          }
        }
        if (deleteFileIds.length > 0) {
          formData.append('deleteFileIds', deleteFileIds);
        }

        if (formData.keys().next().done) {
          this.showToastMessage('danger', '수정된 내용이 없습니다.');
          this.loading = false;
          return;
        }

        // 파일
        // new: true, delete:false 인 것만 
        const response = await axios.post(`chatter/updateRequirement/${this.id}`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: accessToken()
            }
          });

        const status = response.data.status;
        if (status === "200") {
          this.showToastMessage('default', '업데이트를 완료하였습니다.');
          const updatedId = response.data.body.id;
          this.initRequirement(updatedId);
          this.loading = false;
        } else {
          this.showToastMessage('danger', response.data.message);
          this.loading = false;
        }
      } catch (e) {
        this.loading = false;
        this.showToast(e.message, 'danger');
      }
    },
    async downloadFile(file) {
      if (file.fileSize < 0) {
        this.showToastMessage('danger', `${file.name}파일을 찾을 수 없습니다.`);
        return;
      }
      const link = document.createElement('a');
      const url = await this.createFileURL(file);
      if (url) {
        link.href = url;
        link.download = file.name;
        link.click();
      }
    },
    async createFileURL(file) {
      const params = { path: file.path };

      try {
        const response = await axios.post('/chatter/downloadFile',
          params,
          {
            responseType: 'blob',
            headers: { Authorization: accessToken() }
          }
        )

        const resource = response.data;
        return resource ? URL.createObjectURL(resource) : null;
      } catch (e) {
        this.showToastMessage('danger', `${file.name}파일을 찾을 수 없습니다.`);
        return null;
      }
    },
    showRevision(revisionIdx) {
      this.activeRevisionTabIdx = revisionIdx;
    },
    showToastMessage(type, message) {
      this.$bvToast.toast(`${message}`, {
        title: `Notification`,
        toaster: "b-toaster-bottom-center",
        solid: true,
        appendToast: false,
        autoHideDelay: 1000,
        variant: type,
      })
    },
    async cancel() {
      if (this.isNew) {
        if (this.hasFormContent) {
          if (await this.showConfirm('작성된 내용이 저장되지 않았습니다. 페이지를 이동하시겠습니까?')) {
            this.$router.push('/chatter/requirement-list');
          } else {
            return;
          }
        } else {
          this.$router.push('/chatter/requirement-list');
        }
      } else {
        if(this.isChangedForm) {
          if (await this.showConfirm('작성된 내용이 저장되지 않았습니다. 페이지를 이동하시겠습니까?')) {
            this.$router.push('/chatter/requirement-list');
          } else {
            return;
          }
        } else {
          this.$router.push('/chatter/requirement-list');
        }
      }

      // this.$router.push('/chatter/requirement-list');
    },
  },
}

</script>
<style scoped>
@import url('https://hangeul.pstatic.net/hangeul_static/css/nanum-gothic.css');

* {
  font-family: 'NanumGothic';
}


#requirement-container .section {
  background-color: white;
  border-radius: 30px;
  padding: 1.6em;
}

#requirement-container .section.description {
  padding: 0.4em;
}

#requirement-header {
  display: flex;
  align-items: center;
  gap: 1.1rem;
}

#requirement-header .title-wrap {
  padding: 0 0.7em;
  display: flex;
  flex: 3;
  flex-direction: column;
}


#requirement-header .title-wrap .id {
  font-size: 1.1em;
  font-weight: bold;
}

#requirement-header .title-wrap input {
  padding: 0.4em 0;
  border: none;
  font-size: 1.6em;
  font-weight: bold;
  transition: all 0.2s ease-in;
  outline: none;
  border-color: rgb(220, 220, 220);
}


#requirement-header .title-wrap input::placeholder {
  font-weight: normal;
}

#requirement-header .title-wrap input:focus {
  outline: none;
  border-bottom: 1px solid rgb(220, 220, 220);
}

#requirement-header .badge {
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.9em;
  border-radius: 25px;
  background-color: rgb(230, 230, 230);
  padding: 0.6rem;
}

.card-body {
  padding: 0;
}

.card.section {
  margin-bottom: 2rem;
  border-radius: 30px;
  -webkit-box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
  padding: calc(2.0833vw - 10px) 2.0833vw 2.0833vw;
}

.tox .tox-statusbar {
  display: none;
}

.description .tox-tinymce {
  border: none !important;
}

/* File List */
.file-upload-btn-wrap {
  padding-left: 0.7812vw;
}

.file-list {
  /* display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2rem; */
  margin-top: 1.333rem;
}

.file-item {
  position: relative;
  padding: 0.7em;
  margin: 0.5em 0;
  border-radius: 20px;
  border: 1px solid #C4C4CD;
  background-color: #fff;
}

.file-item:hover {
  border-color: #2E2E38;
}

.file-info-area {
  width: 100%;
  display: flex;
  padding-right: 24px;
  align-items: center;
}

.file-info-area .file-info-area_item {
  margin: 0 0.6em;
}

.file-info-area .file-name {
  display: flex;
  align-items: center;
  flex: 3;
  /* width: 100%; */
  height: 30px;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 700;
  line-height: 150%;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  word-break: break-all;
}

.file-info-area .file-upload-time {
  display: block;
  margin-top: 0.133rem;
  color: #747480;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
  flex: 1;
}

.file-info-area .desc-tag-list {
  display: flex;
  gap: 0.666rem;
  flex-wrap: wrap;
  margin-top: 0.8rem;
  margin-bottom: 1.4rem;
  padding: 0;
}

.file-info-area .desc-tag-list .desc-tag-item {
  width: fit-content;
  max-width: 100%;
  padding: 0.3rem 0.8rem;
  list-style: none;
  border-radius: 60px;
  background-color: #F6F6FA;
  color: #747480;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.file-desc-area {
  margin: 0.8rem 0 0.666rem;
  font-size: 0.7rem;
  flex: 3;
}

.file-item .btn-delete {
  position: absolute;
  top: 1.333rem;
  right: 1.333rem;
  display: block;
  width: 20px;
  height: 20px;
  font-size: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15 15L5 5" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M15 5L5 15" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>') center no-repeat transparent;
}

.card.file .file-item .image-item {
  position: relative;
  width: 30px;
  height: 30px;
  padding-bottom: 100%;
  border-radius: 6px;
  overflow: hidden;
}

.card.file .file-item .image-item>div {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.card.file .file-item .image-item>div:hover:after {
  content: '';
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
}

.card.file .file-item .image-item .image-box {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border: unset;
}

.file-size {
  font-size: 0.9rem;
}

.file-size.total,
.file-size.ready-to-upload {
  font-weight: bold;
  font-size: 1rem;
  margin-top: 1rem;
}

.file-size.ready-to-upload span {
  color: red;
  font-size: 0.8rem;
  font-weight: right;
}

/* 하단 버튼 영역 */
.btn-wrap {
  position: sticky;
  bottom: 0;
  display: flex;
  justify-content: end;
  flex-wrap: wrap;
  padding: 1rem 3.125vw;
  gap: 0.666rem;
  align-items: center;
  margin-left: -3.125vw;
  margin-right: -3.125vw;
  z-index: 999;
  background-color: #f6f6fa;
  box-shadow: 0px -10px 30px 0px rgba(46, 46, 56, 0.14);
}

.btn-wrap.bottom {
  box-shadow: none;
}

.btn-wrap .btn-move-wrap {
  display: flex;
  gap: 0 0.8rem;
}

.btn-wrap .text-container .text {
  color: #747480;
  font-family: 'NanumGothic';
  font-size: 12px;
  font-weight: 400;
  line-height: 150%;
}

.btn-wrap .button-container {
  display: flex;
  align-items:center;
  justify-content: space-between;
  gap: 0 10px;
  margin: 0;
  padding: 0;
  width:100%;
}

.invalid-msg {
  color: #ff0000;
}

input.is-invalid {
  outline-color: #ff0000;
  border-color: #ff0000;
}

/** Tabs 영역 공통*/
#requirement-tabs.section {
  padding: 0;
  overflow: hidden;
}

.total-num {
  min-width: 36px;
  padding: 2px 8px;
  border-radius: 40px;
  background-color: #2E2E38;
  color: #FFE305;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 700;
  line-height: 150%;
  text-align: center;
}

.tab-title {
  font-family: "NanumGothic";
  font-size: 1.3rem;
  font-weight: bold;
  padding: 0 0.2rem;
}

.card.related .card-header {
  padding: 0 2.0833vw 10px;
  border-bottom: 0;
}

.card.related .card-header-tabs {
  gap: 0 2rem;
  margin: 0;
  border-bottom: 1px solid #DDDDE3;
}

.card.related .nav-tabs .nav-item {
  margin-bottom: 0;
}

.card.related .nav-tabs .nav-link {
  margin-bottom: 0;
  border-top-left-radius: unset;
  border-top-right-radius: unset;
}

.card.related .nav-tabs .nav-link {
  padding: 2rem 0.666rem 1.066rem;
  border-color: transparent;
  color: #747480;
  font-family: 'NanumGothic';
  font-size: 18px;
  font-weight: 500;
  line-height: 150%;
}

.card.related .nav-tabs .nav-link:hover,
.card.related .nav-tabs .nav-link:focus {
  border-color: transparent;
}

.card.related .nav-tabs .nav-link.active,
.card.related .nav-tabs .nav-item.show .nav-link {
  border-top-left-radius: 30px;
  color: #2E2E38;
  font-weight: 700;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 3px solid #2E2E38;
}

/** Tabs 영역
  Comment
*/
.card.comment .card.comment-reply .ql-toolbar.ql-snow {
  border-top: 1px solid #dddde3;
  border-bottom: 1px solid #dddde3;
  border-left: none;
  border-right: none;
}

.card.comment .comment-list-wrap {
  flex-grow: 1;
  flex-shrink: 0;
  padding-top: max(2rem, 1.5625vw);
  padding-bottom: max(2rem, 1.5625vw);
  padding-left: 2.666rem;
  padding-right: 2.0833vw;
}

.card.comment .comment-list {
  display: flex;
  flex-direction: column;
  gap: 2.666rem 0;
}

.comment .timeline-area {
  width: 100%;
  padding-top: max(2rem, 1.5625vw);
  padding-bottom: max(2rem, 1.5625vw);
  padding-left: 2.666rem;
  padding-right: 2.0833vw;
}

.revision-area {
  padding: 0.866rem 0.866rem 1.666rem;
  width: 100%;
  border-radius: 0.6rem;
  height: 35rem;
  overflow-x: scroll;
}
</style>